/**
 * Database Objects Service - Re-exports from split modules for backward compatibility
 *
 * This file maintains the original API by re-exporting from:
 * - databasesService.ts - Database list fetching
 * - objectsService.ts - Tables, views, procedures, functions fetching
 * - columnsService.ts - Column metadata fetching
 * - queries/index.ts - Engine-specific query definitions
 *
 * All functions now support an optional `engine` parameter to specify
 * the database engine ('mssql' | 'pgsql'). Defaults to 'mssql'.
 */

// Re-export database service
export { getDatabases } from './databasesService';

// Re-export objects service
export { getTables, getViews, getStoredProcedures, getFunctions, getOracleObjects } from './objectsService';

// Re-export columns service
export { getColumns } from './columnsService';
export type { ColumnInfo } from './columnsService';

// Re-export query utilities and engine type
export { getQueries } from './queries';
export type { DatabaseEngine } from './queries';

// Default export for backward compatibility
import { getDatabases } from './databasesService';
import { getTables, getViews, getStoredProcedures, getFunctions, getOracleObjects } from './objectsService';
import { getColumns } from './columnsService';

export default {
  getDatabases,
  getTables,
  getViews,
  getStoredProcedures,
  getFunctions,
  getOracleObjects,
  getColumns
};
